import { render, staticRenderFns } from "./BaseShareProductButton.vue?vue&type=template&id=b1effaa0&"
import script from "./BaseShareProductButton.vue?vue&type=script&lang=js&"
export * from "./BaseShareProductButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1effaa0')) {
      api.createRecord('b1effaa0', component.options)
    } else {
      api.reload('b1effaa0', component.options)
    }
    module.hot.accept("./BaseShareProductButton.vue?vue&type=template&id=b1effaa0&", function () {
      api.rerender('b1effaa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseShareProductButton.vue"
export default component.exports